import React from "react";
import {PdfDialog_SetStateAction, PdfDialogState} from "../state";
import {ViewerApi} from "../viewer/api";


export const usePaging = (state: PdfDialogState, setState: PdfDialog_SetStateAction, viewerApiRef: React.MutableRefObject<ViewerApi | undefined>) => {
    const onPageChangeFocus = () =>
        setState((prev) => ({
            ...prev,
            isInputFocused: true,
        }))

    const onPageBlurFocus = () =>
        setState((prev) => ({
            ...prev,
            isInputFocused: false,
        }))

    const onPageChange = (e, value) => {
        setState((prev) => ({
            ...prev,
            currentPage: value,
        }))

        if (value < 1 || value > state.numPages) {
            return
        }

        viewerApiRef.current?.goToPage(value)
    }
    const updatePageNumber = (pageNumber) =>
        setState((prev) => ({
            ...prev,
            currentPage: pageNumber,
        }))

    const setNumPages = (numPages) =>
        setState((prev) => ({
            ...prev,
            numPages,
        }))

    return {
        onPageChangeFocus,
        onPageBlurFocus,
        onPageChange,
        updatePageNumber,
        setNumPages,
    }
}